import { useAppSelector } from 'hooks/useAppSelector';
import { useOrderType } from 'routes/secondary-market-batch/hooks/use-order-type';

export function useSearchType() {
  const { orderType } = useOrderType();
  return useAppSelector(s => s.workspaces.secondaryMarketBatch.stateByOrderType[orderType].searchType);
}
